import { Stages } from 'utils/enum'
import { QuoteProps } from 'features/quote/components/type'
import { PolicyServiceFormBase } from './PolicyServiceFormBase'

export const ServicesForm = (props: QuoteProps) => {
  return <PolicyServiceFormBase props={props} stage={Stages.STAGE3} />
}
